
import axios from 'axios';

const axiosClient = axios.create({
  // baseURL: 'http://localhost:8285',
  baseURL: 'https://hetras.suza.ac.tz/hetras',
  withCredentials: true,  // IMPORTANT: Send cookies with every request
  headers: {
    'Content-Type': 'application/json',
  }
}); 

export default axiosClient;